const getters = {
}
export default getters


// WEBPACK FOOTER //
// ./module/passport/src/store/getters.js